import { render, staticRenderFns } from "./my-referrer.vue?vue&type=template&id=7093d805&scoped=true&"
import script from "./my-referrer.vue?vue&type=script&lang=js&"
export * from "./my-referrer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7093d805",
  null
  
)

export default component.exports